export const HELM_ITEM_SEPARATOR = '|';

export const HYDROGEN_SYMBOL = 'H';
